import { render, staticRenderFns } from "./JobDetailsAdmin.htm?vue&type=template&id=002a84d2&scoped=true&"
import script from "./JobDetailsAdmin.ts?vue&type=script&lang=js&"
export * from "./JobDetailsAdmin.ts?vue&type=script&lang=js&"
import style0 from "./JobDetailsAdmin.scss?vue&type=style&index=0&id=002a84d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a84d2",
  null
  
)

export default component.exports